// @flow
import type { Epic } from '../../annotations';
import * as r from 'ramda';
import * as most from 'most';
import { select } from 'redux-most';
import { switchMap, fromEagerPromise } from 'most-adjunct';
import * as signals from '../signals';
import * as messages from '../../domain/messages';
import { addLocaleData } from 'react-intl';
import * as mostc from '../../crosscutting/mostc';

const loadScript = (url) => {
  return fromEagerPromise(() => new Promise((resolve, /*reject*/) => {
    const callback = () => resolve();
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    script.onreadystatechange = callback;
    script.onload = callback;
    head.appendChild(script);
  }));
};
// --

const localeEpic = (): Epic => (actions$) => r.pipe(
  select(signals.SEED),
  switchMap(({
    payload,
  }) => {
    /* eslint-disable max-len */
    const polyfillUrl = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl';
    const localeUrl = `https://unpkg.com/react-intl@2.9.0/locale-data/${payload.locale}.js`;
    /* eslint-enable */

    const getPolyfill = () => loadScript(polyfillUrl);
    const getLocale = () => r.ifElse(
      r.equals('en'),
      () => most.of({}),
      () => loadScript(localeUrl).tap(() => {
        addLocaleData(window.ReactIntlLocaleData[payload.locale]);
      }),
    )(payload.locale);

    return r.pipe(
      getPolyfill,
      switchMap(getLocale),
      mostc.map(() => messages.localeLoaded()),
    )(null);
  }),
)(actions$);

export default localeEpic;
